import React, { Component } from "react";
import logo from "../../images/techventurellc-logo.png";

class FooterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.updateIsMobile();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateIsMobile);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateIsMobile);
    }
  }

  updateIsMobile = () => {
    if (typeof window === "undefined") return;

    const byWidth = window.innerWidth <= 768; // tweak breakpoint if you want
    const byUA =
      typeof navigator !== "undefined" &&
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    this.setState({ isMobile: byWidth || byUA });
  };

  render() {
    const { isMobile } = this.state;

    const APP_STORE_URL =
      "https://apps.apple.com/us/app/interview-dojo/id6755057417";
    const PLAY_STORE_URL =
      "https://play.google.com/store/apps/details?id=com.rabin.interviewdojo&pcampaignid=web_share";

    const APP_STORE_BADGE =
      "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";
    const PLAY_STORE_BADGE =
      "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

    const LINKEDIN_URL =
      "https://www.linkedin.com/company/tech-venture-llc/?viewAsMember=true";
    const FACEBOOK_URL = "https://www.facebook.com/IshaniTechNepal";

    // common box so both badges look the same size
    const badgeBoxStyle = {
      width: 160,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const badgeImgStyle = {
      maxWidth: "100%",
      maxHeight: "100%",
      display: "block",
    };

    return (
      <footer
        className="page-footer font-small pt-1"
        style={{ position: "relative", background: "var(--tv-chrome-bg)" }}
      >
        <div className="text-center text-md-left">
          <div className="row mx-0" style={{ borderBottom: "1px solid rgba(255,255,255,.08)" }}>
            {/* ====== Mobile-only App Store / Google Play badges ====== */}
            {isMobile && (
              <div className="col-12 text-center my-3">
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download Interview Dojo on the App Store"
                  >
                    <div style={badgeBoxStyle}>
                      <img
                        src={APP_STORE_BADGE}
                        alt="Download on the App Store"
                        style={badgeImgStyle}
                        loading="lazy"
                      />
                    </div>
                  </a>

                  <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get Interview Dojo on Google Play"
                  >
                    <div style={badgeBoxStyle}>
                      <img
                        src={PLAY_STORE_BADGE}
                        alt="Get it on Google Play"
                        style={badgeImgStyle}
                        loading="lazy"
                      />
                    </div>
                  </a>
                </div>
              </div>
            )}
            {/* ======================================================= */}

            <div className="col-md-4 col-lg-3 mr-auto my-md-4 my-0 mt-4 mb-1 m-5 p5 text-white-50">
              <a href="/aboutUs" className="d-inline-flex align-items-center gap-2 mb-3 text-white text-decoration-none">
                <img src={logo} alt="" className="tv-brand-mark" />
                <span className="h5 mb-0 fw-bold">Tech Venture</span>
              </a>
              <p className="mb-0">
                Curated interview prep, tutorials, and hands-on labs to help
                developers learn faster and get hired.
              </p>
            </div>

            <hr className="clearfix w-100 d-md-none border-secondary" />
            <div className="col-md-2 col-lg-2 mx-auto my-md-4 my-0 mt-4 mb-1 text-white-50">
              <h5 className="font-weight-bold text-uppercase mb-4 text-white">About</h5>

              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="/projects" className="text-white-50">Projects</a>
                </li>
                <li className="mb-2">
                  <a href="/aboutUs" className="text-white-50">About Us</a>
                </li>
                <li className="mb-2">
                  <a href="/blogs" className="text-white-50">Blog</a>
                </li>
                <li className="mb-2">
                  <a href="/badges" className="text-white-50">Certificates</a>
                </li>
              </ul>
            </div>

            <hr className="clearfix w-100 d-md-none border-secondary" />
            <div className="col-md-4 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1 text-white-50">
              <h5 className="font-weight-bold text-uppercase mb-4 text-white">Address</h5>

              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fas fa-home mr-3"></i> Sterling, Virginia,
                  20166, US
                </li>
                <li className="mb-2">
                  <i className="fas fa-envelope mr-3"></i>{" "}
                  <a href="mailto:info@techventurellc.com" className="text-white-50">
                    info@techventurellc.com
                  </a>
                </li>
                <li className="mb-2">
                  <i className="fas fa-phone mr-3"></i>{" "}
                  <a href="tel:+16414513463" className="text-white-50">
                    641-451-3463
                  </a>
                </li>
              </ul>
            </div>

            <hr className="clearfix w-1 d-md-none border-secondary" />
            <div className="col-md-2 col-lg-2 text-center mx-auto my-4">
              <h5 className="font-weight-bold text-uppercase mb-4 text-white">Follow Us</h5>

              {/* Facebook */}
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                type="button"
                className="btn-floating btn-li p-3 text-white-50"
                aria-label="Follow us on Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              {/* LinkedIn */}
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                type="button"
                className="btn-floating btn-li p-3 text-white-50"
                aria-label="Follow us on LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div
          className="footer-copyright text-center py-3 text-white-50"
          style={{ position: "relative" }}
        >
          © {new Date().getFullYear()} Copyright:
          <a href="https://techventurellc.com/" className="text-white-50">
            {" "}
            techventurellc.com
          </a>
        </div>
      </footer>
    );
  }
}

export default FooterComponent;
